/**
 * 关于 DogDisk 单 page 3 tab 页 — 用户协议 / 隐私政策 / 关于
 *
 * 入口:uOqAt 设置 hub `${F}-mi-about` → /about
 *
 * 决策(spec §7):静态 i18n 文案;3 tab 单 page,不拆 sub-route。
 * 根 testid:about-page;tab testid:about-tab-{agreement|privacy|about-dogdisk}。
 *
 * Spec:docs/superpowers/specs/2026-05-26-batch-d-user-routes-design.md §4.1 决策段
 */
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@dogdisk/shared'
import { MobileScreen, TopBar } from '../components/mobile-screen'

type TabKey = 'agreement' | 'privacy' | 'about-dogdisk'

const TABS: ReadonlyArray<{ key: TabKey; label: string }> = [
  { key: 'agreement', label: '用户协议' },
  { key: 'privacy', label: '隐私政策' },
  { key: 'about-dogdisk', label: '关于' },
]

export function AboutPage() {
  const { t } = useTranslation()
  const [active, setActive] = useState<TabKey>('agreement')

  return (
    <MobileScreen>
      <div data-testid="about-page" className="flex min-h-dvh flex-col">
        <TopBar title="关于 绅士网盘" />

        <nav className="flex border-b border-border-subtle bg-white">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              data-testid={`about-tab-${tab.key}`}
              onClick={() => setActive(tab.key)}
              className={cn(
                'flex-1 py-3 text-[14px] font-medium transition-colors',
                active === tab.key
                  ? 'border-b-2 border-brand-500 text-brand-700'
                  : 'text-ink-mute',
              )}
            >
              {tab.label}
            </button>
          ))}
        </nav>

        <main className="flex-1 px-4 py-4 text-[14px] leading-7 text-ink">
          {active === 'agreement' && (
            <article data-testid="about-body-agreement">
              <h3 className="mb-2 text-[15px] font-semibold">
                {t('about.agreement.title', '用户协议')}
              </h3>
              <p>
                {t(
                  'about.agreement.body',
                  '欢迎使用 绅士网盘 私有云盘。使用本服务即表示您同意遵守平台规则:不上传违法/侵权内容;不滥用分享功能;尊重他人隐私。详细条款请联系运营方获取最新版本。',
                )}
              </p>
            </article>
          )}

          {active === 'privacy' && (
            <article data-testid="about-body-privacy">
              <h3 className="mb-2 text-[15px] font-semibold">
                {t('about.privacy.title', '隐私政策')}
              </h3>
              <p>
                {t(
                  'about.privacy.body',
                  '绅士网盘 不会泄露您的文件内容;所有用户数据均采用加密存储;您可随时申请删除账户。第三方支付通道(微信/支付宝)仅获取必要订单字段,不读取文件。',
                )}
              </p>
            </article>
          )}

          {active === 'about-dogdisk' && (
            <article data-testid="about-body-about-dogdisk">
              <h3 className="mb-2 text-[15px] font-semibold">
                {t('about.aboutDogdisk.title', '关于 绅士网盘')}
              </h3>
              <p>
                {t(
                  'about.aboutDogdisk.body',
                  '绅士网盘 是一款面向个人 / 创作者的私有云盘 + 分享与变现平台。支持文件上传 / 分享 / VIP 会员 / 资源包 / 邀请奖励等功能。',
                )}
              </p>
            </article>
          )}
        </main>
      </div>
    </MobileScreen>
  )
}

export default AboutPage
